/**
 * bienestarDetalleConstants.js
 *
 * Constantes y mapas usados por BienestarDetalle y subcomponentes asociados.
 * Se exponen como referencias estables a nivel de módulo (no se recrean en cada render).
 *
 */

export const BIENESTAR_MODAL_PAPER_FLEX = Object.freeze({
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 'calc(100vh - 16px)',
    margin: 8,
});

/**
 * Mapeo de títulos de archivos (normalizados) a códigos de formulario.
 * Se mantiene como objeto plano y congelado: las claves se buscan vía
 * `Object.entries(...)` durante la extracción de un adjunto.
 */
export const MAPEO_TITULOS_CODIGO = Object.freeze({
    'atencion de la emergencia': 'F1_001',
    'atención de la emergencia': 'F1_001',
    'consentimiento informado para la activacion de la ruta vbg': 'F2_002',
    'consentimiento informado para la activación de la ruta vbg': 'F2_002',
    'consentimiento informado para la recepcion de entrevistas de la ruta vbg': 'F2_003',
    'consentimiento informado para la recepción de entrevistas de la ruta vbg': 'F2_003',
    'consentimiento informado para la recepcion de entrevista terceros': 'F2_004',
    'consentimiento informado para la recepción de entrevista terceros': 'F2_004',
    'entrevistas ruta de atencion vbg': 'F2_005',
    'entrevistas ruta de atención vbg': 'F2_005',
    'ruta de atencion acompanamiento integral pedagogico': 'F3_006',
    'ruta de atención acompañamiento integral pedagógico': 'F3_006',
    'ruta de atencion medidas restaurativas de la persona afectada': 'F5_007',
    'ruta de atención medidas restaurativas de la persona afectada': 'F5_007',
    'ruta de atencion socializacion medidas restaurativas persona ofensora': 'F5_008',
    'ruta de atención socialización medidas restaurativas persona ofensora': 'F5_008',
    'ruta de atencion seguimiento a la implementacion de la ruta': 'F6_009',
    'ruta de atención seguimiento a la implementación de la ruta': 'F6_009',
    'acta archivo definitivo': 'T_1',
    'acta de archivo provisional': 'T_2',
    'desistimiento ruta de atencion vbg': 'T_3',
    'desistimiento ruta de atención vbg': 'T_3',
    'psicoeducacion': 'T_4',
    'psicoeducación': 'T_4',
    'comunicacion cierre ruta': 'T_5',
    'comunicación cierre ruta': 'T_5',
});
